<script>
export default {
  name: 'CardNewsItem',
  props: {
    title: {
      type: String,
      required: false,
      default: () => 'Título'
    }
  }
}
</script>

<template>
  <div class="newsItem">
    <div class="wrapper-lg">
      <div class="feed-title font-bold">{{ title }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.pix-codigo {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  min-height: 220px; /* Garante espaço mínimo */
}

.pix-codigo img {
  width: 256px;
  height: 256px;
  object-fit: contain;
}

.newsItem {
  background: #fff;
  border-radius: 8px;
// cursor: pointer;
  display: block;
  max-width: 270px;
  flex: 1;
  float: left;
  /*height: 310px;*/
  margin-left: 12.5px;
  margin-right: 12.5px;
  overflow: auto;
  /*padding-bottom: 162px;*/
  position: relative;
  transition: all .28s cubic-bezier(.15, 0, .15, 1);
  animation-duration: .3s;
  animation-fill-mode: backwards;
  animation-iteration-count: 1;
  animation-name: newsfeedFadeInLeft;
  animation-timing-function: ease-in-out;
  bottom: 0;
  box-shadow: 0 4px 32px 0 rgba(185, 199, 226, .72);
  z-index: 0;
}

.feed-title {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// CardNewsItem.vue?7807416c